var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonnage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 208.159,
    height: 270.044,
    viewBox: "0 0 208.159 270.044",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_117",
    "data-name": "Groupe 117",
    transform: "translate(-166.841 -64.372)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_63",
    "data-name": "Groupe 63",
    transform: "translate(166.841 64.372)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_12",
    "data-name": "Trac\\xE9 12",
    d: "M280,0V5.626h56.259V0Z",
    transform: "translate(-201.237)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13",
    "data-name": "Trac\\xE9 13",
    d: "M240,25.626V20h11.252v5.626H240Z",
    transform: "translate(-172.489 -14.374)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_14",
    "data-name": "Trac\\xE9 14",
    d: "M480,20h16.878V31.252h-5.626V25.626H480Z",
    transform: "translate(-344.978 -14.374)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_15",
    "data-name": "Trac\\xE9 15",
    d: "M200,45.626V40h11.252v5.626H200Z",
    transform: "translate(-143.741 -28.748)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_222",
    "data-name": "Rectangle 222",
    width: 5.8,
    height: 5.8,
    transform: "translate(50.579 16.757)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_223",
    "data-name": "Rectangle 223",
    width: 5.8,
    height: 5.8,
    transform: "translate(140.487 16.757)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16",
    "data-name": "Trac\\xE9 16",
    d: "M151.252,80V96.878h50.633V102.5H185.007v11.252h-5.626V102.5H162.5v11.252h-5.626V102.5h-5.626v33.755h-5.626v-5.626H140v-5.626h5.626V80Z",
    transform: "translate(-100.619 -57.497)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_17",
    "data-name": "Trac\\xE9 17",
    d: "M485.626,80v33.755H480V80Z",
    transform: "translate(-344.978 -57.497)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_18",
    "data-name": "Trac\\xE9 18",
    d: "M360,160h5.626v33.755H360Z",
    transform: "translate(-258.734 -114.993)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19",
    "data-name": "Trac\\xE9 19",
    d: "M465.626,200v11.252H460V200Z",
    transform: "translate(-330.604 -143.741)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20",
    "data-name": "Trac\\xE9 20",
    d: "M480,240h11.252v5.626H480Z",
    transform: "translate(-344.978 -172.489)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_224",
    "data-name": "Rectangle 224",
    width: 5.478,
    height: 5.478,
    transform: "translate(33.823 73.15)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_225",
    "data-name": "Rectangle 225",
    width: 5.478,
    height: 5.478,
    transform: "translate(146.287 73.15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_21",
    "data-name": "Trac\\xE9 21",
    d: "M91.252,280v5.626H102.5v5.626H80v-5.626h5.626V280Z",
    transform: "translate(-57.496 -201.237)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22",
    "data-name": "Trac\\xE9 22",
    d: "M180,280h50.633v5.626H180Z",
    transform: "translate(-129.367 -201.237)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_226",
    "data-name": "Rectangle 226",
    width: 5.8,
    height: 5.8,
    transform: "translate(151.765 78.628)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_23",
    "data-name": "Trac\\xE9 23",
    d: "M500,305.626V300h11.252v5.626H500Z",
    transform: "translate(-359.352 -215.612)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_227",
    "data-name": "Rectangle 227",
    width: 5.478,
    height: 5.478,
    transform: "translate(157.566 84.429)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_228",
    "data-name": "Rectangle 228",
    width: 5.8,
    height: 5.8,
    transform: "translate(16.743 89.907)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_24",
    "data-name": "Trac\\xE9 24",
    d: "M160,320h11.252v5.626h-5.626V342.5H160Z",
    transform: "translate(-114.993 -229.986)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_25",
    "data-name": "Trac\\xE9 25",
    d: "M420,325.626V320h22.5v5.626H420Z",
    transform: "translate(-301.856 -229.986)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_229",
    "data-name": "Rectangle 229",
    width: 5.8,
    height: 5.8,
    transform: "translate(163.044 89.907)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_230",
    "data-name": "Rectangle 230",
    width: 5.478,
    height: 5.478,
    transform: "translate(11.265 95.707)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26",
    "data-name": "Trac\\xE9 26",
    d: "M120,351.252V340h5.626v11.252Z",
    transform: "translate(-86.245 -244.36)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_27",
    "data-name": "Trac\\xE9 27",
    d: "M200,340h61.885v5.626H245.007V362.5h-5.626V345.626H200Z",
    transform: "translate(-143.741 -244.36)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_231",
    "data-name": "Rectangle 231",
    width: 5.478,
    height: 5.478,
    transform: "translate(168.844 95.707)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_28",
    "data-name": "Trac\\xE9 28",
    d: "M25.626,360v11.252H20V360Z",
    transform: "translate(-14.374 -258.734)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_232",
    "data-name": "Rectangle 232",
    width: 5.8,
    height: 5.8,
    transform: "translate(174.323 101.186)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_29",
    "data-name": "Trac\\xE9 29",
    d: "M79.381,503.77h28.13v11.252H90.633v5.626h16.878v16.878H73.755V531.9h5.626V515.022H90.633V509.4H79.381ZM62.5,430.633H79.381v5.626H62.5Zm22.5,0h16.878v5.626H85.007ZM56.878,380v11.252H40v5.626H56.878v28.13H45.626v5.626H56.878V503.77H73.755v22.5H68.13v16.878h45.007V503.77h11.252V531.9h5.626V515.022h11.252V509.4H130.015V503.77h28.13v11.252H141.266v5.626h16.878v16.878H124.389V531.9h-5.626v11.252H163.77V503.77h16.878V486.892h5.626v-5.626h-5.626V475.64h-5.626v22.5H118.763V458.763h-5.626v39.381H73.755V458.763H68.13v39.381H62.5V458.763H68.13v-5.626H62.5V441.885h67.511v5.626h5.626v-5.626h5.626V430.633H135.64v5.626h-28.13v-5.626h28.13v-5.626h-5.626v-5.626h-5.626v5.626H62.5v-5.626H68.13v-5.626H62.5V380Z",
    transform: "translate(-28.748 -273.108)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_30",
    "data-name": "Trac\\xE9 30",
    d: "M505.626,396.878H500V380h5.626v16.878Z",
    transform: "translate(-359.352 -273.108)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_31",
    "data-name": "Trac\\xE9 31",
    d: "M640,380h5.626v11.252H640V380Z",
    transform: "translate(-459.971 -273.108)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32",
    "data-name": "Trac\\xE9 32",
    d: "M0,400v22.5H5.626v-5.626h5.626v-5.626H5.626V400Z",
    transform: "translate(0 -287.482)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33",
    "data-name": "Trac\\xE9 33",
    d: "M145.626,400v28.13H140V400Z",
    transform: "translate(-100.619 -287.482)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_34",
    "data-name": "Trac\\xE9 34",
    d: "M311.252,420v16.878h-5.626V442.5H300V431.252h5.626V420Z",
    transform: "translate(-215.611 -301.856)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_35",
    "data-name": "Trac\\xE9 35",
    d: "M540,425.626V420h16.878v5.626Z",
    transform: "translate(-388.1 -301.856)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36",
    "data-name": "Trac\\xE9 36",
    d: "M660,420h5.626v11.252H660Z",
    transform: "translate(-474.345 -301.856)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_233",
    "data-name": "Rectangle 233",
    width: 5.478,
    height: 5.8,
    transform: "translate(146.287 123.743)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_37",
    "data-name": "Trac\\xE9 37",
    d: "M600,440h11.252v5.626H600Z",
    transform: "translate(-431.223 -316.23)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_38",
    "data-name": "Trac\\xE9 38",
    d: "M505.626,460v11.252H500V460Z",
    transform: "translate(-359.352 -330.604)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_39",
    "data-name": "Trac\\xE9 39",
    d: "M640,460h5.626v11.252H640Z",
    transform: "translate(-459.971 -330.604)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_40",
    "data-name": "Trac\\xE9 40",
    d: "M20,480h5.626v11.252H20V480Z",
    transform: "translate(-14.374 -344.978)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_234",
    "data-name": "Rectangle 234",
    width: 5.478,
    height: 5.478,
    transform: "translate(95.694 135.022)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_235",
    "data-name": "Rectangle 235",
    width: 5.8,
    height: 5.8,
    transform: "translate(89.894 140.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_236",
    "data-name": "Rectangle 236",
    width: 5.8,
    height: 5.8,
    transform: "translate(101.172 140.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_237",
    "data-name": "Rectangle 237",
    width: 5.478,
    height: 5.8,
    transform: "translate(135.008 140.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_238",
    "data-name": "Rectangle 238",
    width: 5.8,
    height: 5.8,
    transform: "translate(174.323 140.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_239",
    "data-name": "Rectangle 239",
    width: 5.478,
    height: 5.478,
    transform: "translate(11.265 146.3)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_240",
    "data-name": "Rectangle 240",
    width: 5.478,
    height: 5.478,
    transform: "translate(106.973 146.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_41",
    "data-name": "Trac\\xE9 41",
    d: "M440,525.626V520h11.252v22.5h-5.626v-5.626H440v-5.626h5.626v-5.626Z",
    transform: "translate(-316.23 -373.727)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_241",
    "data-name": "Rectangle 241",
    width: 5.478,
    height: 5.478,
    transform: "translate(168.844 146.3)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_242",
    "data-name": "Rectangle 242",
    width: 11.279,
    height: 5.8,
    transform: "translate(112.451 151.778)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_42",
    "data-name": "Trac\\xE9 42",
    d: "M585.626,540v16.878H580V540Z",
    transform: "translate(-416.849 -388.101)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_243",
    "data-name": "Rectangle 243",
    width: 5.478,
    height: 5.8,
    transform: "translate(118.252 163.057)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_244",
    "data-name": "Rectangle 244",
    width: 5.8,
    height: 5.478,
    transform: "translate(112.451 168.858)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_43",
    "data-name": "Trac\\xE9 43",
    d: "M480,600h28.13v5.626H491.252v5.626h-5.626v-5.626H480Z",
    transform: "translate(-344.978 -431.223)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_245",
    "data-name": "Rectangle 245",
    width: 5.478,
    height: 5.8,
    transform: "translate(95.694 174.336)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_246",
    "data-name": "Rectangle 246",
    width: 5.478,
    height: 5.8,
    transform: "translate(106.973 174.336)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_247",
    "data-name": "Rectangle 247",
    width: 5.478,
    height: 5.8,
    transform: "translate(118.252 174.336)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_248",
    "data-name": "Rectangle 248",
    width: 5.8,
    height: 5.478,
    transform: "translate(89.894 180.136)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_249",
    "data-name": "Rectangle 249",
    width: 5.8,
    height: 5.478,
    transform: "translate(123.73 180.136)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_250",
    "data-name": "Rectangle 250",
    width: 5.478,
    height: 5.478,
    transform: "translate(146.287 180.136)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_251",
    "data-name": "Rectangle 251",
    width: 5.478,
    height: 5.8,
    transform: "translate(129.53 185.614)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_252",
    "data-name": "Rectangle 252",
    width: 5.8,
    height: 5.8,
    transform: "translate(151.765 185.614)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_253",
    "data-name": "Rectangle 253",
    width: 5.478,
    height: 5.478,
    transform: "translate(135.008 191.415)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_254",
    "data-name": "Rectangle 254",
    width: 5.478,
    height: 5.478,
    transform: "translate(157.566 191.415)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_255",
    "data-name": "Rectangle 255",
    width: 5.8,
    height: 5.8,
    transform: "translate(140.487 196.893)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_256",
    "data-name": "Rectangle 256",
    width: 5.8,
    height: 5.8,
    transform: "translate(163.044 196.893)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_257",
    "data-name": "Rectangle 257",
    width: 5.478,
    height: 5.478,
    transform: "translate(168.844 202.694)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_258",
    "data-name": "Rectangle 258",
    width: 5.8,
    height: 5.478,
    transform: "translate(174.323 208.172)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_259",
    "data-name": "Rectangle 259",
    width: 5.478,
    height: 5.8,
    transform: "translate(157.566 213.65)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_260",
    "data-name": "Rectangle 260",
    width: 5.478,
    height: 5.8,
    transform: "translate(180.123 213.65)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_261",
    "data-name": "Rectangle 261",
    width: 5.8,
    height: 5.478,
    transform: "translate(163.044 219.45)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_262",
    "data-name": "Rectangle 262",
    width: 5.8,
    height: 5.478,
    transform: "translate(185.601 219.45)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_263",
    "data-name": "Rectangle 263",
    width: 5.478,
    height: 5.8,
    transform: "translate(168.844 224.929)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_264",
    "data-name": "Rectangle 264",
    width: 5.478,
    height: 5.8,
    transform: "translate(191.402 224.929)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_265",
    "data-name": "Rectangle 265",
    width: 5.8,
    height: 5.478,
    transform: "translate(174.323 230.729)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_266",
    "data-name": "Rectangle 266",
    width: 5.8,
    height: 5.478,
    transform: "translate(196.88 230.729)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_267",
    "data-name": "Rectangle 267",
    width: 5.478,
    height: 5.8,
    transform: "translate(180.123 236.207)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_44",
    "data-name": "Trac\\xE9 44",
    d: "M691.252,840v11.252H680v5.626h16.878V840Z",
    transform: "translate(-488.719 -603.712)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_268",
    "data-name": "Rectangle 268",
    width: 5.8,
    height: 5.478,
    transform: "translate(185.601 242.008)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_45",
    "data-name": "Trac\\xE9 45",
    d: "M220,240h16.878v11.252H220V240Z",
    transform: "translate(-158.115 -172.489)",
    fill: "#901313",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_46",
    "data-name": "Trac\\xE9 46",
    d: "M185.626,180v5.626h5.626V180H208.13v5.626h5.626V180h11.252v22.5h-5.626v5.626H208.13V196.878H191.252V208.13h-5.626V202.5H180V180Z",
    transform: "translate(-129.367 -129.367)",
    fill: "#ffda99",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_269",
    "data-name": "Rectangle 269",
    width: 5.8,
    height: 5.478,
    transform: "translate(50.579 45.114)",
    fill: "#ffa567"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_47",
    "data-name": "Trac\\xE9 47",
    d: "M220,160h16.878v5.626H220Z",
    transform: "translate(-158.115 -114.993)",
    fill: "#ffa567",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_48",
    "data-name": "Trac\\xE9 48",
    d: "M300,160h16.878v33.755H305.626V188.13h5.626v-22.5H300Z",
    transform: "translate(-215.611 -114.993)",
    fill: "#ffa567",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_270",
    "data-name": "Rectangle 270",
    width: 5.8,
    height: 5.478,
    transform: "translate(50.579 73.15)",
    fill: "#ffa567"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_49",
    "data-name": "Trac\\xE9 49",
    d: "M200,560h16.878v5.626H200Z",
    transform: "translate(-143.741 -402.475)",
    fill: "#ffd82c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_50",
    "data-name": "Trac\\xE9 50",
    d: "M136.878,560v5.626H120V560h16.878Z",
    transform: "translate(-86.245 -402.475)",
    fill: "#7b2424",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_51",
    "data-name": "Trac\\xE9 51",
    d: "M280,565.626V560h28.13v5.626H280Z",
    transform: "translate(-201.237 -402.475)",
    fill: "#7b2424",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_271",
    "data-name": "Rectangle 271",
    width: 5.8,
    height: 5.478,
    transform: "translate(89.894 135.022)",
    fill: "#d73f3f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_272",
    "data-name": "Rectangle 272",
    width: 5.478,
    height: 5.8,
    transform: "translate(95.694 140.5)",
    fill: "#d73f3f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_273",
    "data-name": "Rectangle 273",
    width: 5.8,
    height: 5.478,
    transform: "translate(101.172 146.3)",
    fill: "#d73f3f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_274",
    "data-name": "Rectangle 274",
    width: 5.478,
    height: 5.8,
    transform: "translate(106.973 151.778)",
    fill: "#d73f3f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_275",
    "data-name": "Rectangle 275",
    width: 5.8,
    height: 5.8,
    transform: "translate(123.73 151.778)",
    fill: "#d73f3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_52",
    "data-name": "Trac\\xE9 52",
    d: "M400,560h11.252v5.626h-5.626v5.626H400Z",
    transform: "translate(-287.482 -402.475)",
    fill: "#d73f3f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_276",
    "data-name": "Rectangle 276",
    width: 5.478,
    height: 5.478,
    transform: "translate(106.973 168.858)",
    fill: "#d73f3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_53",
    "data-name": "Trac\\xE9 53",
    d: "M191.252,440h5.626v16.878H202.5V462.5h5.626v5.626H180V462.5h5.626v-5.626h5.626V440Z",
    transform: "translate(-129.367 -316.23)",
    fill: "#e58543",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_54",
    "data-name": "Trac\\xE9 54",
    d: "M180,605.626V600h28.13v5.626H202.5v5.626h-5.626V628.13h-5.626V611.252h-5.626v-5.626Z",
    transform: "translate(-129.367 -431.223)",
    fill: "#e58543",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_55",
    "data-name": "Trac\\xE9 55",
    d: "M156.878,360h33.755v16.878h-5.626v22.5h5.626v5.626h5.626v5.626H179.381v-5.626h-5.626v-5.626H168.13V382.5H162.5v16.878h-5.626v5.626h-5.626v5.626H140v-5.626h5.626v-5.626h5.626v-28.13h5.626Z",
    transform: "translate(-100.619 -258.734)",
    fill: "#e5e2d5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_56",
    "data-name": "Trac\\xE9 56",
    d: "M120,605.626V600h16.878v5.626H142.5v5.626h5.626V628.13h5.626V611.252h5.626v-5.626h5.626V600h16.878v5.626h-5.626v5.626h-5.626v5.626h-5.626v33.755h-5.626v-5.626h-5.626v5.626H148.13v-5.626H142.5v5.626h-5.626V616.878h-5.626v-5.626h-5.626v-5.626Z",
    transform: "translate(-86.245 -431.223)",
    fill: "#e5e2d5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_57",
    "data-name": "Trac\\xE9 57",
    d: "M180,340h5.626v16.878H180V340Z",
    transform: "translate(-129.367 -244.36)",
    fill: "#ccb03b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_58",
    "data-name": "Trac\\xE9 58",
    d: "M320,376.878V360h5.626v16.878Z",
    transform: "translate(-229.985 -258.734)",
    fill: "#ccb03b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_59",
    "data-name": "Trac\\xE9 59",
    d: "M165.626,400v28.13H160V400Z",
    transform: "translate(-114.993 -287.482)",
    fill: "#ccb03b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_60",
    "data-name": "Trac\\xE9 60",
    d: "M305.626,420v11.252H300V420Z",
    transform: "translate(-215.611 -301.856)",
    fill: "#ccb03b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_277",
    "data-name": "Rectangle 277",
    width: 5.8,
    height: 5.8,
    transform: "translate(39.301 140.5)",
    fill: "#ccb03b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_278",
    "data-name": "Rectangle 278",
    width: 5.478,
    height: 5.478,
    transform: "translate(33.823 146.3)",
    fill: "#ccb03b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_279",
    "data-name": "Rectangle 279",
    width: 5.478,
    height: 5.478,
    transform: "translate(95.694 168.858)",
    fill: "#ccb03b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_280",
    "data-name": "Rectangle 280",
    width: 5.478,
    height: 5.8,
    transform: "translate(33.823 174.336)",
    fill: "#ccb03b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_281",
    "data-name": "Rectangle 281",
    width: 5.8,
    height: 5.8,
    transform: "translate(89.894 174.336)",
    fill: "#ccb03b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_282",
    "data-name": "Rectangle 282",
    width: 5.8,
    height: 5.478,
    transform: "translate(39.301 180.136)",
    fill: "#ccb03b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_283",
    "data-name": "Rectangle 283",
    width: 5.478,
    height: 5.478,
    transform: "translate(84.416 180.136)",
    fill: "#ccb03b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_61",
    "data-name": "Trac\\xE9 61",
    d: "M160,660h5.626v33.755h5.626V688.13h5.626v5.626H182.5V688.13h5.626v5.626h5.626V660h5.626v39.381H160Z",
    transform: "translate(-114.993 -474.345)",
    fill: "#ccb03b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_284",
    "data-name": "Rectangle 284",
    width: 5.8,
    height: 5.8,
    transform: "translate(123.73 174.336)",
    fill: "#ca9c9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_62",
    "data-name": "Trac\\xE9 62",
    d: "M460,640h11.252v5.626h5.626v5.626H482.5v5.626h11.252V662.5h5.626v5.626h5.626v5.626h5.626v5.626h5.626v11.252h5.626v5.626h5.626v5.626H516.259v-5.626h-5.626v-5.626h-5.626v-5.626h-5.626v-5.626h-5.626v-5.626H488.13V668.13H482.5V662.5h-5.626v-5.626h-5.626v-5.626h-5.626v-5.626H460Z",
    transform: "translate(-330.604 -459.971)",
    fill: "#ca9c9c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_63",
    "data-name": "Trac\\xE9 63",
    d: "M425.626,580h5.626v5.626h5.626v5.626H442.5v5.626H431.252v-5.626H420v-5.626h5.626Z",
    transform: "translate(-301.856 -416.849)",
    fill: "#b37272",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_285",
    "data-name": "Rectangle 285",
    width: 5.8,
    height: 5.478,
    transform: "translate(140.487 180.136)",
    fill: "#b37272"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_286",
    "data-name": "Rectangle 286",
    width: 5.478,
    height: 5.8,
    transform: "translate(146.287 185.614)",
    fill: "#b37272"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_287",
    "data-name": "Rectangle 287",
    width: 5.8,
    height: 5.478,
    transform: "translate(151.765 191.415)",
    fill: "#b37272"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_288",
    "data-name": "Rectangle 288",
    width: 5.8,
    height: 5.8,
    transform: "translate(185.601 224.929)",
    fill: "#b37272"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_289",
    "data-name": "Rectangle 289",
    width: 5.478,
    height: 5.478,
    transform: "translate(191.402 230.729)",
    fill: "#b37272"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_64",
    "data-name": "Trac\\xE9 64",
    d: "M685.626,840h5.626v11.252H680v-5.626h5.626Z",
    transform: "translate(-488.719 -603.712)",
    fill: "#b37272",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_65",
    "data-name": "Trac\\xE9 65",
    d: "M36.878,320H42.5v5.626H48.13v5.626H42.5v5.626H36.878V342.5H31.252v5.626H25.626v5.626H20V342.5h5.626V331.252h5.626v-5.626h5.626Z",
    transform: "translate(-14.374 -229.986)",
    fill: "#6b4733",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_66",
    "data-name": "Trac\\xE9 66",
    d: "M511.252,320h5.626v5.626H522.5v5.626h5.626V342.5H522.5v5.626h-5.626V342.5h-5.626V331.252H500v-5.626h11.252Z",
    transform: "translate(-359.352 -229.986)",
    fill: "#6b4733",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_67",
    "data-name": "Trac\\xE9 67",
    d: "M131.252,360v11.252h-5.626V388.13H120v-22.5h5.626V360Z",
    transform: "translate(-86.245 -258.734)",
    fill: "#6b4733",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_68",
    "data-name": "Trac\\xE9 68",
    d: "M399.381,360v11.252h-5.626V382.5H388.13v5.626H382.5v11.252H360v-22.5h5.626V365.626h11.252V360h22.5Z",
    transform: "translate(-258.734 -258.734)",
    fill: "#6b4733",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_69",
    "data-name": "Trac\\xE9 69",
    d: "M345.626,640H362.5v5.626h5.626v5.626h5.626v5.626h5.626V668.13h-5.626v5.626H368.13v5.626H340V645.626h5.626Z",
    transform: "translate(-244.36 -459.971)",
    fill: "#6b4733",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_70",
    "data-name": "Trac\\xE9 70",
    d: "M125.626,728.13H120V700h5.626v28.13Z",
    transform: "translate(-86.245 -503.093)",
    fill: "#6b4733",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_290",
    "data-name": "Rectangle 290",
    width: 5.8,
    height: 5.478,
    transform: "translate(151.765 84.429)",
    fill: "#4c2d1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_71",
    "data-name": "Trac\\xE9 71",
    d: "M100,320h16.878v11.252h-5.626v-5.626H100Z",
    transform: "translate(-71.87 -229.986)",
    fill: "#4c2d1c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_72",
    "data-name": "Trac\\xE9 72",
    d: "M500,325.626V320h11.252v5.626H500Z",
    transform: "translate(-359.352 -229.986)",
    fill: "#4c2d1c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_291",
    "data-name": "Rectangle 291",
    width: 5.478,
    height: 5.8,
    transform: "translate(157.566 89.907)",
    fill: "#4c2d1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_73",
    "data-name": "Trac\\xE9 73",
    d: "M420,345.626V340h22.5v5.626Z",
    transform: "translate(-301.856 -244.36)",
    fill: "#4c2d1c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_292",
    "data-name": "Rectangle 292",
    width: 5.8,
    height: 5.478,
    transform: "translate(163.044 95.707)",
    fill: "#4c2d1c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_293",
    "data-name": "Rectangle 293",
    width: 5.8,
    height: 5.8,
    transform: "translate(28.022 101.186)",
    fill: "#4c2d1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_74",
    "data-name": "Trac\\xE9 74",
    d: "M376.878,360v5.626H365.626v11.252H360V360Z",
    transform: "translate(-258.734 -258.734)",
    fill: "#4c2d1c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_75",
    "data-name": "Trac\\xE9 75",
    d: "M500,360h11.252v11.252h5.626v5.626h-5.626V382.5h-5.626V365.626H500Z",
    transform: "translate(-359.352 -258.734)",
    fill: "#4c2d1c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_76",
    "data-name": "Trac\\xE9 76",
    d: "M585.626,360h5.626v5.626h5.626v11.252H602.5V388.13h-5.626V382.5H585.626v-5.626H580v-5.626h5.626V360Z",
    transform: "translate(-416.849 -258.734)",
    fill: "#4c2d1c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_77",
    "data-name": "Trac\\xE9 77",
    d: "M71.252,380v11.252H60v-5.626h5.626V380Z",
    transform: "translate(-43.122 -273.108)",
    fill: "#4c2d1c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_78",
    "data-name": "Trac\\xE9 78",
    d: "M419.381,411.252v5.626h-5.626V428.13H408.13v5.626H396.878v5.626H385.626v-5.626H380V428.13h16.878V416.878H402.5v-5.626h5.626V400h5.626v11.252Z",
    transform: "translate(-273.108 -287.482)",
    fill: "#4c2d1c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_79",
    "data-name": "Trac\\xE9 79",
    d: "M345.626,420v16.878H340V420Z",
    transform: "translate(-244.36 -301.856)",
    fill: "#4c2d1c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_80",
    "data-name": "Trac\\xE9 80",
    d: "M120,460h5.626v11.252H120V460Z",
    transform: "translate(-86.245 -330.604)",
    fill: "#4c2d1c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_294",
    "data-name": "Rectangle 294",
    width: 5.8,
    height: 5.8,
    transform: "translate(101.172 174.336)",
    fill: "#4c2d1c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_295",
    "data-name": "Rectangle 295",
    width: 5.8,
    height: 5.8,
    transform: "translate(112.451 174.336)",
    fill: "#4c2d1c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_296",
    "data-name": "Rectangle 296",
    width: 5.478,
    height: 5.478,
    transform: "translate(95.694 180.136)",
    fill: "#4c2d1c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_297",
    "data-name": "Rectangle 297",
    width: 5.478,
    height: 5.478,
    transform: "translate(118.252 180.136)",
    fill: "#4c2d1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_81",
    "data-name": "Trac\\xE9 81",
    d: "M120,660h5.626v11.252H120V660Z",
    transform: "translate(-86.245 -474.345)",
    fill: "#4c2d1c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_82",
    "data-name": "Trac\\xE9 82",
    d: "M325.626,660v33.755h28.13V688.13h5.626V682.5h5.626V671.252h5.626v5.626h5.626v22.5H320V660Z",
    transform: "translate(-229.985 -474.345)",
    fill: "#4c2d1c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_298",
    "data-name": "Rectangle 298",
    width: 5.8,
    height: 5.8,
    transform: "translate(123.73 185.614)",
    fill: "#4c2d1c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_299",
    "data-name": "Rectangle 299",
    width: 5.478,
    height: 5.478,
    transform: "translate(129.53 191.415)",
    fill: "#4c2d1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_83",
    "data-name": "Trac\\xE9 83",
    d: "M180,825.626V820h28.13v11.252H191.252v-5.626H180Z",
    transform: "translate(-129.367 -589.338)",
    fill: "#2e3049",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_84",
    "data-name": "Trac\\xE9 84",
    d: "M360,820h28.13v11.252H371.252v-5.626H360Z",
    transform: "translate(-258.734 -589.338)",
    fill: "#2e3049",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_85",
    "data-name": "Trac\\xE9 85",
    d: "M208.13,20h56.259v5.626h11.252v5.626H264.389v5.626h-5.626V42.5h-5.626V48.13H213.755v5.626H180V36.878h5.626V31.252h11.252V25.626H208.13Z",
    transform: "translate(-129.367 -14.374)",
    fill: "#7a95b3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_300",
    "data-name": "Rectangle 300",
    width: 5.8,
    height: 5.8,
    transform: "translate(123.73 61.871)",
    fill: "#7a95b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_86",
    "data-name": "Trac\\xE9 86",
    d: "M411.252,240v5.626H400V240Z",
    transform: "translate(-287.482 -172.489)",
    fill: "#7a95b3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_87",
    "data-name": "Trac\\xE9 87",
    d: "M131.252,276.878v-5.626H120v-5.626h5.626V260h5.626v5.626h5.626v11.252Z",
    transform: "translate(-86.245 -186.863)",
    fill: "#7a95b3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_88",
    "data-name": "Trac\\xE9 88",
    d: "M295.641,271.252H284.389v5.626h-22.5V282.5H200v-5.626h45.007v-5.626h11.252v-5.626h5.626v5.626h5.626v-5.626h5.626V260h16.878v5.626h5.626Z",
    transform: "translate(-143.741 -186.863)",
    fill: "#7a95b3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_89",
    "data-name": "Trac\\xE9 89",
    d: "M20,451.252v-5.626h5.626V440h5.626v5.626h5.626V462.5H42.5v5.626H31.252V462.5H25.626V451.252Z",
    transform: "translate(-14.374 -316.23)",
    fill: "#7a95b3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_90",
    "data-name": "Trac\\xE9 90",
    d: "M513.755,440v16.878H508.13V468.13H496.878v11.252H485.626v5.626H480V462.5h5.626v-5.626h5.626V445.626h5.626V440Z",
    transform: "translate(-344.978 -316.23)",
    fill: "#7a95b3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_91",
    "data-name": "Trac\\xE9 91",
    d: "M180,860h11.252v5.626h5.626v5.626H180Z",
    transform: "translate(-129.367 -618.086)",
    fill: "#7a95b3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_92",
    "data-name": "Trac\\xE9 92",
    d: "M360,860h11.252v5.626h5.626v5.626H360Z",
    transform: "translate(-258.734 -618.086)",
    fill: "#7a95b3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_93",
    "data-name": "Trac\\xE9 93",
    d: "M160,925.626V920h16.878v5.626Z",
    transform: "translate(-114.993 -661.208)",
    fill: "#7a95b3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_94",
    "data-name": "Trac\\xE9 94",
    d: "M340,925.626V920h16.878v5.626Z",
    transform: "translate(-244.36 -661.208)",
    fill: "#7a95b3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_301",
    "data-name": "Rectangle 301",
    width: 5.478,
    height: 5.8,
    transform: "translate(135.008 16.757)",
    fill: "#517398"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_95",
    "data-name": "Trac\\xE9 95",
    d: "M350.633,80v33.755h-5.626v5.626h-5.626v5.626H328.13v5.626h11.252v-5.626h11.252v5.626h-5.626v5.626h-5.626v5.626h-5.626v-5.626H328.13v5.626H316.878v-5.626H322.5V102.5h-5.626V96.878H300V91.252h39.381V85.626h5.626V80Z",
    transform: "translate(-215.611 -57.497)",
    fill: "#517398",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_96",
    "data-name": "Trac\\xE9 96",
    d: "M230.633,300v5.626H180V300h50.633Z",
    transform: "translate(-129.367 -215.612)",
    fill: "#517398",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_97",
    "data-name": "Trac\\xE9 97",
    d: "M60,445.626V440H71.252v22.5H65.626V445.626Z",
    transform: "translate(-43.122 -316.23)",
    fill: "#517398",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_98",
    "data-name": "Trac\\xE9 98",
    d: "M596.878,460v11.252h-5.626v5.626h-5.626V482.5H580V471.252h5.626V460h11.252Z",
    transform: "translate(-416.849 -330.604)",
    fill: "#517398",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_99",
    "data-name": "Trac\\xE9 99",
    d: "M522.5,540v16.878H500v-5.626h11.252V540Z",
    transform: "translate(-359.352 -388.101)",
    fill: "#517398",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_100",
    "data-name": "Trac\\xE9 100",
    d: "M208.13,896.878H191.252v-5.626H180v-5.626h16.878V880H208.13Z",
    transform: "translate(-129.367 -632.46)",
    fill: "#517398",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_101",
    "data-name": "Trac\\xE9 101",
    d: "M388.13,896.878H371.252v-5.626H360v-5.626h16.878V880H388.13Z",
    transform: "translate(-258.734 -632.46)",
    fill: "#517398",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonnage);
export default __webpack_public_path__ + "static/media/personnage.4afa5eedef892bc0791364642e99f154.svg";
export { ForwardRef as ReactComponent };